<!--封装地图控件，集成多加地图-->
<template>
  <div :id="mapId" style="height: 100%; width: 100%">
    <!--地图-->
  </div>
</template>
<script>
import { mapState } from "vuex";
import { BaiduMap } from "./maps/BaiduMap.js";
import { GoogleMap } from "./maps/GoogleMap.js";
export default {
  name: "KingLongMap",
  props: {
    mapId: {
      type: String,
      default: "kinglongMap",
    },
    coordsType: {
      type: Number,
      default: 5,//3 wgs84 5 gc_02 9  bd_09
    },
  },
  data() {
    return {
      map: undefined,
      markerClusterer: "",
      zoom: 12,
      markerArr: [],
      overlayArr: [],
      visibilityState: "visible",
      intervalFlag: "",
      trafficCtrl: "",
      myDistanceToolObject: "",
    };
  },
  computed: {
    ...mapState({
      mapConfig: (state) => {
        if (state.user.operator.Latitude && state.user.operator.Longitude) {
          console.log({
            mapCenter: state.user.operator.Longitude + "," + state.user.operator.Latitude,
            mapZoom: 15
          })
          return {
            mapCenter: state.user.operator.Longitude + "," + state.user.operator.Latitude,
            mapZoom: 15
          }
        }
        return state.user.mapConfig;
      },
    }),
  },

  mounted() {
    var t = this;
    setTimeout(() => {
      this.initMap();
    }, 1000);
    document.onvisibilitychange = function () {
      window.clearInterval(t.intervalFlag),
        (t.intervalFlag = ""),
        (t.visibilityState = document.visibilityState);
    };
  },
  methods: {
    removeClustererById(id) {
      if (this.map) {
        this.map.removeClustererById(id)
      }
    },

    addMarkerToCluster(id, title, lon, lat, icon, callback) {
      // console.log('addMarkerToCluster-', id, title, lon, lat, icon, callback)
      if (this.map) this.map.addMarkerToCluster(id, title, lon, lat, icon, callback);
    },
    showCluster() {
      if (this.map) this.map.showCluster();
    },
    initMap() {


      this.map = new (this.$store.getters.mapType === 'google' ? GoogleMap : BaiduMap)(); // new BaiduMap(); new GoogleMap();


      this.map.initMap(this.mapId, {
        coordsType: this.coordsType,//BMAP_COORD_GCJ02 
        center: this.mapConfig && this.mapConfig.mapCenter
          ? this.mapConfig.mapCenter.split(",")
          : undefined,
        zoom: this.mapConfig && this.mapConfig.mapZoom ? this.mapConfig.mapZoom : this.zoom,
        completed: () => {
          this.$emit("LoadCompleted");
        },
      });
    },

    DrawRectangleCompleted(left_lng, left_lat, right_lng, right_lat) {
      this.$emit(
        "DrawRectangleCompleted",
        left_lng,
        left_lat,
        right_lng,
        right_lat
      );
    },
    DrawPolygonCompleted(lnglats) {
      this.$emit("DrawPolygonCompleted", lnglats);
    },
    DrawCircleCompleted(lng, lat, radius) {
      this.$emit("DrawCircleCompleted", lng, lat, radius);
    },
    DrawPolyLineCompleted(lnglats) {
      this.$emit("DrawPolyLineCompleted", lnglats);
    },
    DrawPointCompleted(lng, lat) {
      this.$emit("DrawPointCompleted", lng, lat);
    },

    setCenter(lng, lat) {
      if (this.map) this.map.setCenter(lng, lat);
    },

    cancelDraw() {
      if (this.map) this.map.cancelDraw();
    },
    drawRectangle(width, color, fillColor,callback) {
      if (this.map)
        this.map.drawRectangle(
          width,
          color,
          fillColor,
          callback || this.DrawRectangleCompleted
        );
    },
    drawPolygon(width, color, fillColor) {
      if (this.map)
        this.map.drawPolygon(
          width,
          color,
          fillColor,
          this.DrawPolygonCompleted
        );
    },
    drawCircle(width, color, fillColor) {
      if (this.map)
        this.map.drawCircle(width, color, fillColor, this.DrawCircleCompleted);
    },
    drawLine(width, color) {
      if (this.map) this.map.drawLine(width, color, this.DrawPolyLineCompleted);
    },
    drawPoint() {
      if (this.map) this.map.drawPoint(this.DrawPointCompleted);
    },
    clearAll() {
      if (this.map) this.map.clearAll();
    },
    clearMarkers() {
      if (this.map) this.map.clearMarkers();
    },
    removeMarkerById(id) {
      if (this.map) this.map.removeMarkerById(id);
    },

    removePolylineById(id) {
      if (this.map) this.map.removePolylineById(id);
    },
    addMarker(id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight) {
      if (this.map) this.map.addMarker(id, name, lng, lat, iconUrl, callback, iconWidth, iconHeight);
    },
    removePolygonById(id) {
      if (this.map) this.map.removePolygonById(id);
    },
    addPolygon(id, name, coordanites, strokeWidth, strokeColor, fillColor) {
   
      if (this.map)
        this.map.addPolygon(
          id,
          name,
          coordanites,
          strokeWidth,
          strokeColor,
          fillColor
        );
    },
    addPolyline(id, name, coordanites, strokeWidth, strokeColor, isArrow) {
      if (this.map)
        this.map.addPolyline(id, name, coordanites, strokeWidth, strokeColor, isArrow);
    },

    addCircle(id, lnglat, radius, strokeWidth, strokeColor, fillColor) {
      if (this.map)
        this.map.addCircle(
          id,
          lnglat,
          radius,
          strokeWidth,
          strokeColor,
          fillColor
        );
    },

    centerAndZoom(lng, lat, zoom) {
      if (this.map) this.map.centerAndZoom(new BMap.Point(lng, lat), zoom);
    },
    setCenter(lng, lat) {
      if (this.map) this.map.setCenter(lng, lat);
    },


    setViewport(view) {
      if (this.map) this.map.setViewport(view);
    },
    removeOverlay(overlay) {
      if (this.map) this.map.removeOverlay(overlay);
    },
    clearOverlay() {
      if (this.map) this.map.clearAll();
    },
    addOverlay(overlay) {
      if (this.map) this.map.addOverlay(overlay);
    },
    openInfoWindow(infoWindow, point) {
      if (this.map) this.map.openInfoWindow(infoWindow, point);
    },
    pointToLineDist(x1, y1, x2, y2, x0, y0) {
      if (this.map) return this.map.pointToLineDist(x1, y1, x2, y2, x0, y0);
    },
  },
};
</script>
